import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// The native navigation bar shows the page's h1 as title and the team name as subtitle. A list page can offer its
// counter ("30 Buchungen") as subtitle instead, the bar follows when the counter changes (filters).
export default class extends BridgeComponent {
  static component = "page"

  connect() {
    super.connect()

    this.sendPage()
    this.observeCounter()
  }

  disconnect() {
    this.observer?.disconnect()
    super.disconnect()
  }

  sendPage() {
    const title = document.querySelector(".inner h1")?.textContent.trim()
    const counter = document.querySelector("[data-bridge-subtitle-source]")?.textContent.trim()
    const subtitle = counter || this.bridgeElement.bridgeAttribute("subtitle")
    this.send("connect", { title, subtitle })
  }

  observeCounter() {
    const counter = document.querySelector("[data-bridge-subtitle-source]")
    if (!counter) return

    this.observer = new MutationObserver(() => this.sendPage())
    this.observer.observe(counter, { childList: true, characterData: true, subtree: true })
  }
}
